module.exports = __webpack_public_path__ + "static/media/products-banner.f4213737.jpg";